import { useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";

import clientApi from "api";
import { useAppSelector } from "./redux";
import { useQuery } from "./useQuery";
import {
  getCurrentStoryItemSelector,
  getHiveSelector,
  getStoryUuidSelector,
} from "store/reducers/hive";

interface FetchParams {
  ctaName: string;
  pageName: string;
  organizationUuid?: string;
  currentStoryId?: number;
  segmentId?: string;
  request?: any;
  storyUuid?: string;
  origin?: string;
  origin2?: string;
}

const REF_KEY = "ref";

const fetch = async (params: FetchParams) => {
  await clientApi.community.fetchCTALogs({
    sessionId: clientApi.sessionId,
    appName: "stories",
    ...params,
  });
};

export const useAnalytics = () => {
  const searchParams = useQuery();
  const location = useLocation();

  const ref = location.search.split("?")[2];
  const origin2 = location.search.split("?")[3];
  const hiveDetails = useAppSelector(getHiveSelector);

  const currentStory = useAppSelector(getCurrentStoryItemSelector);

  const handleAnalyticsEvent = useCallback(async (e: any) => {
    // if (hiveDetails) {
    await fetch({
      //   organizationUuid: hiveDetails?.communityUuid,
      ...e?.detail,
    });
    if (ref) {
      await fetch({
        // organizationUuid: hiveDetails?.communityUuid,
        origin: ref,
        origin2: origin2,
        ...e?.detail,
      });
      // ref = null;
    }
    // }
  }, []);

  useEffect(() => {
    window.addEventListener("analyticsEvent", handleAnalyticsEvent);
    return () => {
      window.removeEventListener("analyticsEvent", handleAnalyticsEvent);
    };
  }, [handleAnalyticsEvent]);

  const storyUuid = useAppSelector(getStoryUuidSelector);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent<FetchParams>("analyticsEvent", {
        detail: {
          ctaName: "changePage",
          pageName: location.pathname.slice(1),
          storyUuid: storyUuid,
          origin: ref || "",
          origin2: origin2 || "",
          // organizationUuid: hiveDetails.communityUuid,
        },
      })
    );
  }, [location.pathname, hiveDetails?.communityUuid]);

  useEffect(() => {
    window.dispatchEvent(
      new CustomEvent<FetchParams>("analyticsEvent", {
        detail: {
          ctaName: "changeStory",
          pageName: location.pathname.slice(1),
          currentStoryId: currentStory?.storyItemId,
          request: currentStory?.storyItemId,
          storyUuid: storyUuid,
          // organizationUuid: hiveDetails.communityUuid,
        },
      })
    );
  }, [currentStory]);
};
